import { useQuery } from "@tanstack/react-query";
import { eventsService, summaryService } from "@/services/api";

export const useMonthSummary = (month) =>
  useQuery({ queryKey: ["summary", "month", month], queryFn: () => summaryService.month(month) });

export const useRaioX = () => useQuery({ queryKey: ["summary", "raiox"], queryFn: summaryService.raiox });

export const useYearSummary = (year) =>
  useQuery({ queryKey: ["summary", "year", year], queryFn: () => summaryService.year(year) });

export const useSuggestions = () => useQuery({ queryKey: ["summary", "suggestions"], queryFn: summaryService.suggestions });
export const useInvestments = () => useQuery({ queryKey: ["summary", "investments"], queryFn: summaryService.investments, refetchInterval: 5 * 60 * 1000 });
export const useInvoices = (month) => useQuery({ queryKey: ["summary", "invoices", month], queryFn: () => summaryService.invoices(month) });

export const useSplit = () => useQuery({ queryKey: ["summary", "split"], queryFn: summaryService.split });

// Momentos do casal com recorrência expandida (invalidado junto com "summary" ao criar/editar eventos)
export const useAgenda = (params) =>
  useQuery({ queryKey: ["summary", "agenda", params], queryFn: () => eventsService.agenda(params) });
